<template>
  <div>
    <!-- Start Footer Area -->
    <footer class="footer-section pt-100">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-footer-widget">
              <h3>Contact info</h3>

              <div class="footer-info-contact">
                <i class="flaticon-pin"></i>
                <h3>Location</h3>
                <span>
                  P O Box 193ABF Block 8
                  <br />Gaborone, Botswana
                </span>
              </div>

              <div class="footer-info-contact">
                <i class="flaticon-call"></i>
                <h3>Call Us</h3>
                <span>
                  <a href="tel:+26774103043">+26774103043</a>
                </span>
              </div>

              <div class="footer-info-contact">
                <i class="flaticon-email"></i>
                <h3>Email Us</h3>
                <span>
                  <a href="mailto:hello@huruma.com">admin@clcentre.org</a>
                </span>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-footer-widget">
              <h3>Programs</h3>

              <ul class="footer-quick-links">
                <li>
                  <a href="/ipdyi">IPDYI</a>
                </li>
                <li>
                  <a href="/rhema-prophetic-centre">Rhema Prophetic Centre</a>
                </li>
                <li>
                  <a href="/business-leadership-institute">Business and Leadership Institute</a>
                </li>
                <li>
                  <a href="/trauma-healing-centre">Trauma healing centre</a>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-lg-2 col-md-6 col-sm-6">
            <div class="single-footer-widget">
              <h3>About</h3>

              <ul class="footer-quick-links">
                <li>
                  <a href="/gallery">Gallery</a>
                </li>
                <li>
                  <a href="/faq">FAQ</a>
                </li>
                <li>
                  <a href="https://drive.google.com/folderview?id=0B7vFk0DueDXCTTdoU25TYlNoLVk&usp=sharing">Resources</a>
                </li>
                <li>
                  <a href="/register">Form</a>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 col-sm-6">
            <div class="single-footer-widget">
              <h3>Social Media Links</h3>
              <div class="footer-social">
                <a
                  href="https://www.Facebook.com/rhemapropheticcentre"
                  target="_blank"
                >
                  <button
                    type="button"
                    class="btn btn-social-icon btn-facebook mb-2"
                  >
                    <i class="fa flaticon-facebook" />
                  </button> </a
                ><br />
                <a
                  href="https://www.instagram.com/city.lifecentre/?hl=en"
                  target="_blank"
                >
                  <button
                    type="button"
                    class="btn btn-social-icon btn-instagram mb-2"
                  >
                    <i class="fa flaticon-instagram" /></button></a
                ><br />
                <a
                  href="https://www.youtube.com/channel/UCqyIe-Fk9vxWl_mTb-P4QXA"
                  target="_blank"
                >
                  <button type="button" class="btn btn-social-icon btn-youtube">
                    <i class="fa fa-youtube-play"></i></button
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="copyright-area">
        <div class="container">
          <div class="copyright-area-content">
            <div class="row align-items-center">
              <div class="col-lg-4">
                <div class="copyright-logo">
                  <img src="assets/img/clc_logo.jpg" alt="image" />
                </div>
              </div>

              <div class="col-lg-4 col-md-6">
                <p>
                  <i class="far fa-copyright"></i>
                  2020 City Life Centre. All Rights Reserved
                </p>
              </div>

              <div class="col-lg-4 col-md-6">
                <ul>
                  <li>
                    <a href="terms-condition.html">Terms & Conditions</a>
                  </li>
                  <li>
                    <a href="privacy-policy.html">Privacy Policy</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!-- End Footer Area -->

    <!-- Start Go Top Section -->
    <div class="go-top">
      <i class="bx bx-chevron-up"></i>
      <i class="bx bx-chevron-up"></i>
    </div>
    <!-- End Go Top Section -->
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped></style>
